import { motion } from 'framer-motion';
import { Answer, CreateAnswerDto } from '@/types/workerInfo.types';
import { TextInput } from '../inputs/TextInput';
import { NumberInput } from '../inputs/NumberInput';
import { BooleanInput } from '../inputs/BooleanInput';
import { DateInput } from '../inputs/DateInput';
import { SingleChoiceInput } from '../inputs/SingleChoiceInput';
import { DocumentInput } from '../inputs/DocumentInput';
import { CategoryHeader } from '../common/CategoryHeader';
import { colors, spacing } from '@/theme';
import { MultipleChoiceInput } from '../inputs/MultipleChoiceInput';
import { MunicipioSelect } from '@/components/SelectMunicipio';

interface PersonalCategoryProps {
  answers: Answer[];
  progress: number;
  onUpdateAnswer: (questionId: string, data: Partial<CreateAnswerDto>) => Promise<void>;
  saving: boolean;
}

export function PersonalCategory({ answers, progress, onUpdateAnswer, saving }: PersonalCategoryProps) {

  const renderInput = (answer: Answer) => {
    const { question, id, questionId } = answer;
    const commonProps = {
      key: id || questionId,
      answer,
      onBlur: async (value: any) => {
        try {
          await onUpdateAnswer(questionId, value);
        } catch (error) {
          console.error('Error updating:', error);
        }
      },
      disabled: saving,
    };

    switch (question.type) {
      case 'text':
        return <TextInput {...commonProps} />;
      case 'city': 
      // @ts-ignore
        return <MunicipioSelect {...commonProps} />;
      case 'number':
        return <NumberInput {...commonProps} />;
      case 'boolean':
        return <BooleanInput {...commonProps} />;
      case 'date':
        return <DateInput {...commonProps} />;
      case 'multiple_choice':
        return <MultipleChoiceInput {...commonProps} options={question.options || []} />;
      case 'single_choice':
        return <SingleChoiceInput {...commonProps} options={question.options || []} />;
      case 'document':
        return <DocumentInput {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }}>
      <CategoryHeader
        icon="👤"
        title="Informacion personal"
        description="Datos basicos, preferencias y expectativas laborales."
        progress={progress}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing[3] }}>
        {answers.map((answer, index) => (
          <motion.div
            key={answer.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03 }}
            style={{
              padding: spacing[4],
              borderRadius: 16,
              border: `1px solid ${colors.gray[100]}`,
              backgroundColor: colors.white,
            }}
          >
            {renderInput(answer)}
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
